import React from 'react';
import { Button } from 'antd';
import { withRouter } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

const BackButton = ({ history }) => <Button shape='circle' icon={<ArrowLeftOutlined />} onClick={() => history.goBack()} />;

export default withRouter(BackButton);
